import $ from '../$';
import { getStyle } from '../utils';
import './each';
import './hide';
import './show';
/**
 * 切换元素的显示状态
 */
$.fn.toggle = function () {
    return this.each(function () {
        getStyle(this, 'display') === 'none' ? $(this).show() : $(this).hide();
    });
};
